import React from "react";
import "../../styles/Home/Footer.css";

const Footer = () => {
  return (
    <footer class="footer">
      <div class="footer-section">
        <h4>Call us</h4>
        <p>123 456 7890</p>
        <p>329 Queensberry Street, North Melbourne VIC 3051, Australia.</p>
        <p>support@superio.com</p>
      </div>

      <div class="footer-section">
        <h4>For Candidates</h4>
        <ul>
          <li>Browse Jobs</li>
          <li>Browse Categories</li>
          <li>Candidate Dashboard</li>
          <li>Job Alerts</li>
          <li>My Bookmarks</li>
        </ul>
      </div>

      <div class="footer-section">
        <h4>About Us</h4>
        <ul>
          <li>Browse Jobs</li>
          <li>Browse Categories</li>
          <li>Candidate Dashboard</li>
          <li>Job Alerts</li>
          <li>My Bookmarks</li>
        </ul>
      </div>

      <div class="footer-section">
        <h4>Helpful</h4>
        <ul>
          <li>Browse Jobs</li>
          <li>Browse Categories</li>
          <li>Candidate Dashboard</li>
          <li>Job Alerts</li>
          <li>My Bookmarks</li>
        </ul>
      </div>

      <div class="footer-icons">
        <i class="fab fa-facebook"></i>
        <i class="fab fa-instagram"></i>
        <i class="fab fa-twitter"></i>
        <i class="fab fa-youtube"></i>
      </div>
    </footer>
  );
};

export default Footer;
